<template>
  <div id="listbox">
    <img
      src="@/assets/img/YonghuiSync/post2.png"
      v-show="![1].includes(+$route.query.type)"
    />
    <!-- <h5>如有疑问，请通过咚咚联系下单店铺的在线客服。</h5> -->
    <ul class="lists">
      <li v-for="item in lists" :key="item.id">
        <div class="header">
          兑换码:
          <div class="omit">{{ item.redeCodeNo }}</div>
        </div>
        <!-- gcShape 0：卡号卡密 1：卡密 2：卡号短链 3：卡号短链验证码 -->
        <div class="info">
          <div class="title">兑换时间</div>
          <div class="omit">
            {{ common.formatDate(item.excTime, '{yyyy}/{mm}/{dd}') || '-' }}
          </div>
        </div>
        <div class="info" v-show="![1].includes(+$route.query.type)">
          <div class="title">店铺订单号</div>
          <div class="omit">
            {{ item.outOrdNo || '-' }}
          </div>
        </div>
        <div class="info">
          <div class="title">商品名称</div>
          <div class="omit">
            {{ item.gcName || '-' }}
          </div>
        </div>
        <template v-if="[0].includes(item.gcShape)">
          <div class="info">
            <div class="title">卡&nbsp;&nbsp;&nbsp;号</div>
            <div class="omit">{{ item.cardNo }}</div>
            <div
              class="btn"
              v-clipboard:copy="item.cardNo"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="info">
            <div class="title">密&nbsp;&nbsp;&nbsp;码</div>
            <div class="omit">{{ item.cardPwd }}</div>
            <div
              class="btn"
              v-clipboard:copy="item.cardPwd"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
        </template>
        <div class="info" v-if="[1].includes(item.gcShape)">
          <div class="title">卡&nbsp;&nbsp;&nbsp;密</div>
          <div class="omit">{{ item.cardPwd }}</div>
          <div
            class="btn"
            v-clipboard:copy="item.cardPwd"
            v-clipboard:success="copySuccess"
            v-clipboard:error="copyError"
          >
            复制
          </div>
        </div>
        <div class="info" v-if="[2].includes(item.gcShape)">
          <div class="title">短&nbsp;&nbsp;&nbsp;链</div>
          <div class="omit">{{ item.shortUrl }}</div>
          <div
            class="btn"
            v-clipboard:copy="item.shortUrl"
            v-clipboard:success="copySuccess"
            v-clipboard:error="copyError"
          >
            复制
          </div>
        </div>
        <template v-if="[3].includes(item.gcShape)">
          <div class="info">
            <div class="title">卡&nbsp;&nbsp;&nbsp;号</div>
            <div class="omit">{{ item.cardNo }}</div>
            <div
              class="btn"
              v-clipboard:copy="item.cardNo"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="info">
            <div class="title">短&nbsp;&nbsp;&nbsp;链</div>
            <div class="omit">{{ item.shortUrl }}</div>
            <div
              class="btn"
              v-clipboard:copy="item.shortUrl"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="info">
            <div class="title">密&nbsp;&nbsp;&nbsp;码</div>
            <div class="omit">{{ item.verifyCode }}</div>
            <div
              class="btn"
              v-clipboard:copy="item.verifyCode"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
        </template>
        <div class="info">
          <div class="title">有效期</div>
          <div class="omit">
            {{ common.formatDate(item.virtualEndTime, '{yyyy}/{mm}/{dd}') }}
          </div>
        </div>
      </li>
    </ul>
    <div class="describe" v-if="describe">
      <div class="title">商品使用说明</div>
      <div class="text" v-html="describe"></div>
    </div>
  </div>
</template>

<script>
import { listRedeemCodeForSyncLink } from '@/api/fsl.js'
export default {
  data() {
    return {
      lists: [],
      describe: undefined
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const { code, data, message } = await listRedeemCodeForSyncLink(
        this.$route.query
      )
      if (code === 0) {
        this.lists = data?.outStorageDetailsVOList || []
        this.describe = data?.describe
      } else {
        this.$toast.fail({
          message: message
        })
      }
    },
    copySuccess() {
      this.$toast({
        message: '复制成功'
      })
    },
    copyError() {
      this.$toast({
        message: '复制失败'
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/style/YonghuiSync.less';
.describe {
  margin: -3vw 3vw 7.15vw;
  background: linear-gradient(0deg, #fd5b50, #fd866a);
  border-radius: 15px;
  line-height: 1.5;
  padding: 3.9vw;
  font-size: 3.6vw;
  color: #ffffff;
  .title {
    font-size: 4.16vw;
    padding-bottom: 2vw;
  }
  img {
    display: block;
    width: 100%;
  }
}
</style>
